import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { Dispatch, SetStateAction, useState } from 'react'
import { useUserRQInfo } from '../user-provider/user-provider'
import { TDesktopDropDownOverlay } from '../HeaderV2/types/types'
import { eventData, eventMapping } from './header.tracking'
import { clearCookies, clearLocalStorage } from '@/root/utils/logout-utils'
// import HelpIcon from '@/stories/assets/header/help.svg'
import { BETA_INDSTOCKS_HOST, INDSTOCKS_HOST } from '@/root/constants/common'
import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'
import PrettyBlueButton, {
  PrettyGreenButton,
} from '@/components/Stocks/TransactionSystem/PrettyBlueButton'
import { HEADER_RIGHT_CTA_CLICK } from '@/root/constants/mixpanel-constants'

const FloatingQRScanner = dynamic(
  () => import('../LoginWidget/QRScanner/FloatingQRScanner'),
  { ssr: false },
)
const LoginWidgetV2 = dynamic(() => import('../LoginWidget/LoginWidgetV2'), {
  ssr: false,
})

// This is for Dweb
export const HeaderRight = ({
  host,
  toggleDwebDropdown,
  closeNavigation,
}: {
  host?: string
  toggleDwebDropdown?: Dispatch<SetStateAction<TDesktopDropDownOverlay>>
  closeNavigation?: () => void
}) => {
  const isStocksFunnel = host === INDSTOCKS_HOST || host === BETA_INDSTOCKS_HOST
  const [openLoginModal, setOpenLoginModal] = useState(false)
  // const [openFloatingQR, setOpenFloatingQR] = useState(true)
  const { isNotAuthenticated } = useUserRQInfo()
  const { asPath, push, query } = useRouter()
  // const link =
  //   host === INDSTOCKS_HOST
  //     ? 'customer-service?topic_id=9&searchFilter=FAQ'
  //     : '/customer-service'

  const pushEvent = useAnalyticsEvent()
  const onClickHandler = (label: string) => {
    closeNavigation?.()

    if (toggleDwebDropdown) {
      toggleDwebDropdown(null)
    }

    const event = eventMapping[eventData.headerLoginSignupCtaClick]
    clearCookies()
    clearLocalStorage()

    const mixpanelEventPayload = {
      eventName: HEADER_RIGHT_CTA_CLICK,
      payload: {
        cta_name: label,
        url: host,
        path_name: asPath,
        ...(query.utms && { utms: query.utms }),
      },
    }
    pushEvent({
      gtm4Payload: {
        eventData: {
          ...event,
          eventLabel: label,
        },
      },
      mixpanelEventPayload,
    })
    const path = asPath

    if (isStocksFunnel) {
      void push(
        `/login?return_to=${decodeURI(
          path.substring(0, 1000),
        )}${`&hostname=${INDSTOCKS_HOST}`}`,
      )
    } else {
      setOpenLoginModal(true)
    }
  }

  return (
    <>
      <LoginWidgetV2
        openModal={openLoginModal}
        onClose={() => setOpenLoginModal(false)}
        isStocksFunnel={isStocksFunnel}
      />
      {isNotAuthenticated && !openLoginModal && (
        <FloatingQRScanner
          hideInMweb={true}
          onClickHandler={() => setOpenLoginModal(true)}
          toggleDwebDropdown={toggleDwebDropdown}
        />
      )}

      <div className="block items-center">
        {isNotAuthenticated && (
          <div className="flex items-center gap-2.5">
            {/* {<div
              className="hover:bg-brand-grey-background cursor-pointer rounded-full p-2"
              onClick={() => {
                const gtm4Payload = {
                  eventData: eventMapping[eventData.headerHelpCenterIconClick],
                }
                pushEvent({ gtm4Payload })
                closeNavigation?.()
                void push(link)
              }}
              title="Customer Service"
            >
              <HelpIcon className="aspect-square w-6" />
            </div>} */}
            <PrettyBlueButton
              borderColorPrimary="border-brand-green-dark"
              backgroundColorSecondary="bg-brand-white hover:bg-brand-green-dark"
              textColorPrimary="text-brand-green-dark hover:text-white"
              paddingClassNames="!rounded-3xl py-2.5 px-6 text-sm leading-5 lg:px-8 whitespace-nowrap"
              marginClassNames="m-0"
              primary={false}
              hover={false}
              text="Login"
              shadows={false}
              onClick={() => {
                onClickHandler('Log In')
              }}
            />
            <PrettyGreenButton
              text="Open Demat Account"
              paddingClassNames="!rounded-3xl py-2.5 px-6 text-sm leading-5 lg:px-6 whitespace-nowrap"
              marginClassNames="m-0"
              shadows={false}
              onClick={() => {
                onClickHandler('Open Demat Account')
              }}
            />
          </div>
        )}
      </div>
    </>
  )
}
